import { Button } from "reactstrap";
import { FormattedMessage, injectIntl, intlShape } from "react-intl";

export function DisconnectTeacherFromClassButton(props) {
  return (
    <div>
      <Button
        size="sm"
        color="primary"
        disabled={props.removingTeacher}
        outline
        title={
          props.removingTeacher
            ? props.intl.formatMessage({ id: "TeacherIsBeingRemoved" })
            : props.intl.formatMessage({ id: "DetachTeacher" })
        }
        onClick={() => props.promptRemoveTeacher(props.teacher)}
      >
        <FormattedMessage id="DetachTeacher" />
      </Button>
    </div>
  );
}
DisconnectTeacherFromClassButton.propTypes = {
  intl: intlShape.isRequired,
};
export default injectIntl(DisconnectTeacherFromClassButton);
